import { render, staticRenderFns } from "./PxBooleanSimNao.vue?vue&type=template&id=ffe7e99a&"
import script from "./PxBooleanSimNao.vue?vue&type=script&lang=js&"
export * from "./PxBooleanSimNao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports